import {
  Box,
  Button,
  ButtonBase,
  ListItemIcon,
  Menu,
  MenuItem,
  MenuList,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import SimpleBarHorizontal from "components/SimpleBarHorizontal";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import {
  deleteCabinThunk,
  getCabinsByMachineThunk,
} from "store/reducers/vending";
import CabinCrudDialog from "pages/vending/cabin/dialogs/CabinCrudDialog";

const CabinList = ({
  m_id,
  currentItem,
  setCurrentItem,
  selectedItem,
  setSelectedItem,
  editable = true,
}) => {
  const vendingState = useSelector((state) => state.vending);

  const [contextMenu, setContextMenu] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClose = () => {
    setAnchorEl(null);
    setContextMenu(null);
  };

  useEffect(() => {
    dispatch(getCabinsByMachineThunk(m_id));
  }, [m_id]);

  const handleContextMenu = (event, item) => {
    event.preventDefault();
    setCurrentItem(item);
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
          }
        : null
    );
  };

  const handleDelete = () => {
    dispatch(deleteCabinThunk({ id: currentItem.id, m_id: m_id }));
  };

  useEffect(() => {
    const cabinsForMachine = vendingState.cabins[m_id];
    if(!selectedItem && cabinsForMachine && cabinsForMachine.length > 0) {
      setSelectedItem(cabinsForMachine[0]);
    }
    
  }, [vendingState.cabins, m_id, selectedItem, setSelectedItem]);

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setCurrentItem(item);
  };

  const [openUpdateDialog, setOpenUpdateDialog] = React.useState(false);
  const handleUpdateDialogClose = () => {
    setOpenUpdateDialog(false);
  };

  const menu = (context) => (
    <Menu
      {...(context
        ? {
            open: contextMenu !== null,
            anchorReference: "anchorPosition",
            anchorPosition:
              contextMenu !== null
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined,
          }
        : {
            anchorEl: anchorEl,
            open: anchorEl !== null,
          })}
      onClose={handleClose}
      onClick={handleClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuList dense={false}>
        <MenuItem onClick={handleDelete}>
          <ListItemIcon>
            <DeleteOutlineIcon />
          </ListItemIcon>
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenUpdateDialog(true);
          }}
        >
          <ListItemIcon>
            <UpgradeIcon />
          </ListItemIcon>
          Update
        </MenuItem>
      </MenuList>
    </Menu>
  );

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" color="text.primary">
          Please select a cabin
        </Typography>
        {editable && (
          <Button
            size="small"
            variant="outlined"
            sx={{ mt: 1 }}
            onClick={() => setOpenUpdateDialog(true)}
          >
            Add new cabin
          </Button>
        )}
      </Stack>
      <SimpleBarHorizontal>
        <Stack spacing={1} direction="row" paddingY={1}>
          {vendingState.cabins[m_id]?.map((cabin) => (
            <ButtonBase key={cabin.id}>
              <Paper
                sx={{
                  width: 200,
                  padding: 1,
                  ...(selectedItem?.id === cabin.id && {
                    backgroundColor: "primary.lighter",
                  }),
                }}
                onContextMenu={(e) => handleContextMenu(e, cabin)}
                elevation={selectedItem?.id === cabin.id ? 4 : 1}
                onClick={() => setSelectedItem(cabin)}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box>
                    <Typography variant="h5">Cabin {cabin.number}</Typography>
                    <Typography variant="h6">
                      Total trays : {cabin.tray_count}
                    </Typography>
                  </Box>
                  {editable && (
                    <MoreVertIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClick(e, cabin);
                      }}
                      sx={{ marginRight: 1 }}
                      color="text.secondary"
                    />
                  )}
                </Stack>
              </Paper>
            </ButtonBase>
          ))}
        </Stack>
        {editable && (
          <>
            {menu(true)}
            {menu(false)}
          </>
        )}
      </SimpleBarHorizontal>

      <CabinCrudDialog
        open={openUpdateDialog}
        handleClose={handleUpdateDialogClose}
        m_id={m_id}
        cabin={currentItem}
        setCurrentItem={setCurrentItem}
        number={
          vendingState.cabins[m_id]?.length > 0
            ? vendingState.cabins[m_id][vendingState.cabins[m_id]?.length - 1]
                .number + 1
            : 1
        }
      />
    </Box>
  );
};

export default CabinList;
